"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = exports.Timestamp = exports.Text = exports.SnackbarContent = exports.SnackbarContainer = exports.SnackWrapper = exports.SnackElement = exports.SeeAllBtn = exports.ReadBtn = exports.Icon = exports.Content = exports.CloseBtn = exports.ButtonBox = exports.Button = exports.ActionsContainer = exports.Actions = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../../constants");
var _Button = require("../../../../components/Button");
var _Toast = _interopRequireDefault(require("../../../../components/Toast"));
var _styles = require("../../../../components/Toast/styles");
var _OptionClose = _interopRequireDefault(require("../../../../components/Icons/OptionClose"));
var _SnackStatus = _interopRequireDefault(require("../icons/SnackStatus"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const fadeInAnimation = (0, _styledComponents.keyframes)(["0%{transform:scale(0.1);opacity:0;}60%{transform:scale(1.05);opacity:1;}100%{transform:scale(1);opacity:1;}"]);
const fadeOutAnimation = (0, _styledComponents.keyframes)(["0%{transform:scale(1);opacity:1;}75%{transform:translateX(400px);opacity:0;padding:5px 0;}100%{max-height:0;padding:0;opacity:0;}"]);
const ReadBtn = exports.ReadBtn = (0, _styledComponents.default)(_SnackStatus.default).withConfig({
  displayName: "styles__ReadBtn",
  componentId: "sc-1m0tc6m-0"
})(["fill:", ";height:", ";width:", ";&:hover{fill:", ";}"], ({
  theme
}) => theme.colors.appFrame.snack.readBtn, ({
  theme
}) => theme.AppFrame.snack.readBtnHeight, ({
  theme
}) => theme.AppFrame.snack.readBtnWidth, ({
  theme
}) => theme.colors.appFrame.snack.readBtnHover);
const CloseBtn = exports.CloseBtn = (0, _styledComponents.default)(_OptionClose.default).withConfig({
  displayName: "styles__CloseBtn",
  componentId: "sc-1m0tc6m-1"
})(["", ""], ({
  theme
}) => (0, _styledComponents.css)(["height:", ";width:", ";fill:", ";&:hover{fill:", ";}"], theme.AppFrame.snack.closeBtnHeight, theme.AppFrame.snack.closeBtnWidth, theme.colors.appFrame.snack.closeBtn, theme.colors.appFrame.snack.closeBtnHover));
const Button = exports.Button = (0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "styles__Button",
  componentId: "sc-1m0tc6m-2"
})(["text-align:left;", " &:hover{color:", ";}", " ", ""], ({
  theme
}) => (0, _styledComponents.css)(["font-size:", ";font-weight:", ";line-height:", ";margin:", ";color:", ";height:", ";"], theme.AppFrame.snack.button.fontSize, theme.AppFrame.snack.button.fontWeight, theme.AppFrame.snack.button.lineHeight, theme.AppFrame.snack.button.btnMargin, theme.colors.appFrame.snack.link, theme.AppFrame.snack.button.height), ({
  theme
}) => theme.colors.appFrame.snack.linkHover, ({
  theme
}) => theme.name === _constants.THEMES.mds && (0, _styledComponents.css)(["min-width:50px;padding:5px 15px;border-color:", ";&:hover,&:active{background-color:", ";border-color:", ";}"], theme.AppFrame.snack.button.border, theme.colors.appFrame.snack.background, theme.AppFrame.snack.button.border), ({
  theme
}) => theme.name !== _constants.THEMES.mds && (0, _styledComponents.css)(["letter-spacing:1px;max-width:100%;"]));
const Toast = exports.Toast = (0, _styledComponents.default)(_Toast.default).withConfig({
  displayName: "styles__Toast",
  componentId: "sc-1m0tc6m-3"
})(["position:absolute;z-index:400;transition:left 0.3s ease-in-out;right:0;width:auto;", " ", "{transition:width 0.3s ease-in-out;}", " ", " ", ";"], ({
  theme
}) => theme.name !== _constants.THEMES.mds && (0, _styledComponents.css)(["left:0;height:48px;"]), _styles.NotificationItem, ({
  minimized,
  theme
}) => minimized && (0, _styledComponents.css)(["left:", ";"], theme.AppFrame.menu.collapsedWidth), ({
  fullWidth,
  theme
}) => fullWidth && (0, _styledComponents.css)(["left:", ";"], theme.AppFrame.menu.expandedWidth), ({
  theme
}) => theme.name === _constants.THEMES.mds && (0, _styledComponents.css)(["position:relative;left:0;", "{width:100%;}"], _styles.NotificationItem));
const SnackElement = exports.SnackElement = _styledComponents.default.div.withConfig({
  displayName: "styles__SnackElement",
  componentId: "sc-1m0tc6m-4"
})(["", " border-left:4px solid #fff;border-radius:1px;display:flex;flex-direction:row;box-shadow:0 2px 14px 0 rgba(0,0,0,0.07),0 0 5px 0 rgba(0,0,0,0.1),0 12px 20px -8px rgba(0,0,0,0.12);pointer-events:all;padding:", ";"], ({
  theme
}) => (0, _styledComponents.css)(["background:", ";font-family:", ";font-size:", ";font-weight:", ";"], theme.colors.appFrame.snack.background, theme.fonts.preferred, theme.AppFrame.snack.fontSize, theme.AppFrame.snack.fontWeight), ({
  theme
}) => theme.AppFrame.snack.body.padding);
const SnackWrapper = exports.SnackWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__SnackWrapper",
  componentId: "sc-1m0tc6m-5"
})(["padding:5px 0;max-height:450px;opacity:0;transition:height 0.3s linear;transform:translate3d(0,0,0);pointer-events:auto;", ";", ";", ";", ";"], ({
  visible
}) => visible && `
    opacity: 1;
  `, ({
  fadeIn
}) => fadeIn && (0, _styledComponents.css)(["animation-name:", ";animation-duration:0.5s;animation-timing-function:ease-in;animation-fill-mode:forwards;"], fadeInAnimation), ({
  fadeOut
}) => fadeOut && (0, _styledComponents.css)(["animation-name:", ";animation-duration:0.5s;animation-timing-function:ease-in;animation-fill-mode:forwards;"], fadeOutAnimation), ({
  unread,
  theme
}) => unread && (0, _styledComponents.css)(["", "{background-color:", ";}"], SnackElement, theme.colors.appFrame.bellWidget.itemHoverBg));
const Icon = exports.Icon = _styledComponents.default.div.withConfig({
  displayName: "styles__Icon",
  componentId: "sc-1m0tc6m-6"
})(["text-align:center;flex-shrink:0;"]);
const Content = exports.Content = _styledComponents.default.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1m0tc6m-7"
})(["flex:1;margin:", ";"], ({
  theme
}) => theme.AppFrame.snack.body.contentMargin);
const Text = exports.Text = _styledComponents.default.span.withConfig({
  displayName: "styles__Text",
  componentId: "sc-1m0tc6m-8"
})(["display:block;padding:4px 0;max-height:360px;overflow:hidden;word-break:break-word;", " ", ""], ({
  theme
}) => (0, _styledComponents.css)(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";"], theme.fonts.preferred, theme.AppFrame.snack.body.fontSize, theme.AppFrame.snack.body.lineHeight, theme.AppFrame.snack.body.fontWeight, theme.colors.appFrame.snack.text), ({
  theme
}) => theme.name === _constants.THEMES.mds && (0, _styledComponents.css)(["padding:0;"]));
const Actions = exports.Actions = _styledComponents.default.div.withConfig({
  displayName: "styles__Actions",
  componentId: "sc-1m0tc6m-9"
})(["", ""], ({
  theme
}) => theme.name !== _constants.THEMES.mds && (0, _styledComponents.css)(["padding:4px 0;max-height:62px;"]));
const ActionsContainer = exports.ActionsContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__ActionsContainer",
  componentId: "sc-1m0tc6m-10"
})(["position:relative;", ""], ({
  theme
}) => theme.name === _constants.THEMES.mds && (0, _styledComponents.css)(["display:flex;flex-direction:column-reverse;"]));
const Timestamp = exports.Timestamp = _styledComponents.default.div.withConfig({
  displayName: "styles__Timestamp",
  componentId: "sc-1m0tc6m-11"
})(["padding-top:4px;", ""], ({
  theme
}) => (0, _styledComponents.css)(["font-size:", ";font-weight:", ";line-height:", ";color:", ";"], theme.AppFrame.snack.timestamp.fontSize, theme.AppFrame.snack.timestamp.fontWeight, theme.AppFrame.snack.timestamp.lineHeight, theme.colors.appFrame.bellWidget.itemDate));
const ButtonBox = exports.ButtonBox = _styledComponents.default.div.withConfig({
  displayName: "styles__ButtonBox",
  componentId: "sc-1m0tc6m-12"
})(["cursor:pointer;text-align:center;", ";& > svg path{transition:all 0.2s ease-out;}"], ({
  empty
}) => empty && `
    cursor: default;
  `);
const SnackbarContainer = exports.SnackbarContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__SnackbarContainer",
  componentId: "sc-1m0tc6m-13"
})(["position:absolute;", " right:0;margin:0 12px 16px;overflow-x:hidden;overflow-y:auto;z-index:1000;transition:all 0.2s linear;", ";", ";scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{width:0px;}"], ({
  theme
}) => (0, _styledComponents.css)(["max-height:calc(100% - ", ");top:calc(", " + ", ");"], theme.AppFrame.header.height, theme.AppFrame.snack.topPadding, theme.AppFrame.header.height), ({
  reduced
}) => reduced && (0, _styledComponents.css)(["transform:translateY(444px);height:calc(100% - 444px);"]), ({
  topBased
}) => topBased && (0, _styledComponents.css)(["top:8px;"]));
const SnackbarContent = exports.SnackbarContent = _styledComponents.default.div.withConfig({
  displayName: "styles__SnackbarContent",
  componentId: "sc-1m0tc6m-14"
})(["width:", ";"], ({
  theme
}) => theme.AppFrame.snack.containerWidth);
const SeeAllBtn = exports.SeeAllBtn = (0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "styles__SeeAllBtn",
  componentId: "sc-1m0tc6m-15"
})(["font-size:16px;line-height:24px;"]);